import { connect } from 'react-redux';
import HoldOrderPage from './HoldOrderPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, getHoldOrderData, rework } from 'src/actions/liveOrderAction';
import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        liveOrderDataOnHold: state.liveOrder.liveOrderDataOnHold
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getHoldOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getHoldOrderData);
        },
        reload: () => {
            dispatch(getHoldOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Initial Scan'));
        },
        submitRework: (column: Object) => {
            dispatch(rework(column, 'hold'));
        },
    };
};

const LiveOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(HoldOrderPage);

export default LiveOrderContainer;



// WEBPACK FOOTER //
// ./src/components/HoldOrderPage/HoldOrderPageContainer.tsx